export default "__VITE_ASSET__8IU$$Cia__"